import Vue from 'vue';
import Main from '../../components/content/Main'

Vue.component('Main', Main)
